var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9 17.5V7.5M9 17.5C9 18.6046 8.10457 19.5 7 19.5H5C3.89543 19.5 3 18.6046 3 17.5V7.5C3 6.39543 3.89543 5.5 5 5.5H7C8.10457 5.5 9 6.39543 9 7.5M9 17.5C9 18.6046 9.89543 19.5 11 19.5H13C14.1046 19.5 15 18.6046 15 17.5M9 7.5C9 6.39543 9.89543 5.5 11 5.5H13C14.1046 5.5 15 6.39543 15 7.5M15 17.5V7.5M15 17.5C15 18.6046 15.8954 19.5 17 19.5H19C20.1046 19.5 21 18.6046 21 17.5V7.5C21 6.39543 20.1046 5.5 19 5.5H17C15.8954 5.5 15 6.39543 15 7.5",
    stroke: "#818586",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/Groups.723ab94c72b735afd1cd0de2c2b503c9.svg";
export { ForwardRef as ReactComponent };